var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Drawer, Grid, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon, MessageDownload01Icon } from 'hugeicons-react';
import { Icon } from '@iconify/react';
import { nanoid } from '@reduxjs/toolkit';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setSideBarState } from '../../../../../application/features/common/commonSlice';
import { useAppDispatch, useAppSelector } from '../../../../../application/store/useStore';
import useTranslate from '../../../../../localization/helpers';
import FileViewerDialog from '../../../chats/chat-section/components/ai-message/file-viewer';
import UserMessage from '../../../chats/chat-section/components/user-message';
import ViewDocument from '../../../knowledge/view-document';
import AiAuditMessage from '../ai-audit-message';
var AuditFeedback = function (_a) {
    var documents = _a.documents, messages = _a.messages, downloadChatDisabled = _a.downloadChatDisabled, handleDownloadClick = _a.handleDownloadClick, documentDetailsLoading = _a.documentDetailsLoading, documentDetails = _a.documentDetails;
    var theme = useTheme();
    var navigate = useNavigate();
    var translate = useTranslate().translate;
    var sideBar = useAppSelector(function (state) { return state.common; }).sideBar;
    var dispatch = useAppDispatch();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isIpad = useMediaQuery('(min-width: 767px) and (max-width: 1024px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var handleBackClick = function () {
        navigate(-1);
    };
    var _b = __read(useState(false), 2), isAccordionExpanded = _b[0], setAccordionExpanded = _b[1];
    var _c = __read(useState(isAccordionExpanded), 2), accordionOpen = _c[0], setAccordionOpen = _c[1];
    var accordionRef = useRef(null);
    var _d = __read(useState(false), 2), isDocumentViewOpen = _d[0], setDocumentViewOpen = _d[1];
    var _e = __read(useState([]), 2), selectedSources = _e[0], setSelectedSources = _e[1];
    var _f = __read(useState(), 2), selectedDocument = _f[0], setSelectedDocument = _f[1];
    var _g = __read(useState(), 2), selectedSource = _g[0], setSelectedSource = _g[1];
    var _h = __read(useState([]), 2), selectedDocContent = _h[0], setSelectedDocContent = _h[1];
    var _j = __read(useState(''), 2), selectedMessageId = _j[0], setSelectedMessageId = _j[1];
    var _k = __read(useState(''), 2), selectedDocumentName = _k[0], setSelectedDocumentName = _k[1];
    var _l = __read(useState(''), 2), selectedScrollId = _l[0], setSelectedScrollId = _l[1];
    var _m = __read(useState(false), 2), isExpanded = _m[0], setIsExpanded = _m[1];
    var _o = __read(useState(''), 2), selectedUuid = _o[0], setSelectedUuid = _o[1];
    var _p = __read(useState({ isOpen: false }), 2), viewDocument = _p[0], setViewDocument = _p[1];
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (accordionRef.current && !accordionRef.current.contains(event.target)) {
                setAccordionOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var onViewDocument = function (document) {
        return setViewDocument({ isOpen: true, document: document });
    };
    var toggleAccordion = function () {
        setAccordionExpanded(!isAccordionExpanded);
    };
    var toggleExpanded = function () { return setIsExpanded(!isExpanded); };
    var handleUuidSelection = function (uuid) {
        setSelectedUuid(uuid);
        setSelectedScrollId(nanoid());
    };
    var handleTranslatedTextSelection = function (text) { };
    var handleSourceSelection = function (contentDto) {
        if (contentDto.doc_content_id) {
            var filteredChatDtos = messages
                .map(function (chatDto) {
                var filteredSource = chatDto.sources.find(function (source) { return source.document === contentDto.document && source.page === contentDto.page; });
                return filteredSource || null;
            })
                .filter(function (source) { return source !== null; })[0];
            setSelectedDocumentName(contentDto.document);
            setSelectedSource(filteredChatDtos);
            setSelectedDocument(documents.find(function (x) { return x.document_name === contentDto.document; }));
        }
    };
    var handleViewDocumentOpen = function (chatDto) {
        if (sideBar.isOpen)
            dispatch(setSideBarState({
                isOpen: false,
                reason: 'system'
            }));
        setSelectedSources(chatDto.sources);
        setSelectedDocContent(chatDto.doc_content);
        setSelectedMessageId(chatDto.message_id);
        setDocumentViewOpen(true);
    };
    var handleViewDocumentClose = function () {
        setDocumentViewOpen(false);
        if (!sideBar.isOpen && sideBar.reason === 'system')
            dispatch(setSideBarState({
                isOpen: true,
                reason: 'user'
            }));
    };
    var handleContentSelection = function (contentDtos, content_id) {
        var _a;
        setSelectedDocContent([]);
        var documentName = ((_a = contentDtos.find(function (content) { return content.doc_content_id === content_id; })) === null || _a === void 0 ? void 0 : _a.document) || '';
        var contents = contentDtos.filter(function (content) { return content.document === documentName; });
        setSelectedDocContent(contents);
    };
    var handleSourcesSelection = function (messageId) {
        var message = messages.find(function (message) { return message.message_id === messageId; });
        if (message) {
            setSelectedSources(message.sources);
            setSelectedMessageId(messageId);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, p: isXs ? undefined : isSm ? 2 : 1, children: [_jsx(Grid, { size: {
                            xs: 12,
                            sm: isDocumentViewOpen && isExpanded ? 3 : isDocumentViewOpen && !isXs && !isIpad ? 6 : 12
                        }, display: 'flex', sx: {
                            height: isIpad
                                ? 'calc(100svh - 246px)'
                                : isscreen600900Landscape
                                    ? 'calc(100svh - 150px)'
                                    : { md: 'calc(100svh - 246px)', xs: 'calc(100svh - 182px)' }
                        }, children: _jsxs(Box, { height: isXs
                                ? 'calc(100svh - 232px)'
                                : isscreen600900Landscape
                                    ? 'calc(100svh - 150px)'
                                    : 'calc(100svh - 175px)', display: 'flex', flexDirection: 'column', width: '100%', sx: {
                                backgroundColor: theme.palette.background.default,
                                borderBottomLeftRadius: '0px',
                                borderTopLeftRadius: '0px',
                                borderTopRightRadius: isDocumentViewOpen && !isXs && !isIpad ? '0px !important' : undefined,
                                borderBottomRightRadius: isDocumentViewOpen && !isXs && !isIpad ? '0px !important' : undefined,
                                borderRadius: { md: '0 24px 24px 0', xs: 2 },
                                boxShadow: '0 10px 48px 0 #919EAB29',
                                overflowY: 'hidden',
                                position: 'relative'
                            }, children: [_jsxs(Accordion, { expanded: accordionOpen, ref: accordionRef, disabled: documentDetailsLoading, onChange: function (e, expanded) { return setAccordionOpen(expanded); }, sx: {
                                        position: 'absolute',
                                        width: '100%',
                                        zIndex: 1,
                                        boxShadow: 'none'
                                    }, disableGutters: true, children: [_jsxs(AccordionSummary, { "aria-controls": 'panel1a-content', id: 'panel1a-header', sx: {
                                                backgroundColor: 'white',
                                                '.MuiAccordionSummary-content': {
                                                    my: { md: 1.5, xs: 0.5 }
                                                }
                                            }, children: [isscreen600900Landscape && (_jsx(Box, { display: 'flex', flexDirection: 'row', gap: 0.2, alignItems: 'center', children: _jsx(IconButton, { color: 'primary', onClick: handleBackClick, children: _jsx(ArrowLeft02Icon, { size: 24 }) }) })), _jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', children: _jsx(Button, { variant: 'text', sx: {
                                                            fontSize: '18px',
                                                            fontWeight: 700,
                                                            color: '#161C24',
                                                            '&:hover': {
                                                                backgroundColor: '#FFFFFF',
                                                                color: '#161C24'
                                                            }
                                                        }, onClick: toggleAccordion, endIcon: isAccordionExpanded ? (_jsx(Icon, { icon: 'eva:arrow-ios-upward-fill' })) : (_jsx(Icon, { icon: 'eva:arrow-ios-downward-fill' })), children: translate('common.documents') }) }), _jsx(Box, { children: _jsx(IconButton, { disabled: downloadChatDisabled, onClick: function (event) {
                                                            event.stopPropagation();
                                                            handleDownloadClick();
                                                        }, children: _jsx(MessageDownload01Icon, {}) }) })] }), _jsx(AccordionDetails, { sx: {
                                                backgroundColor: 'white',
                                                maxHeight: isscreen600900Landscape ? '100px' : '400px',
                                                overflow: 'auto',
                                                borderRadius: 2
                                            }, children: documentDetails.map(function (document) { return (_jsx(Box, { padding: '16px', width: '100%', boxShadow: '0 10px 48px 0 #919EAB29', display: 'flex', borderRadius: '12px', sx: { cursor: 'pointer' }, onClick: function () { return onViewDocument(document); }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', width: '100%', gap: 0.5, children: [_jsx(Typography, { variant: 'subtitle2', sx: { wordBreak: 'break-all' }, children: document.title }), _jsx(Box, { display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', children: document.fileName }) }), _jsx(Tooltip, { title: document.aiSummary, arrow: true, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', sx: {
                                                                    display: '-webkit-box',
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: 'vertical',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }, children: document.aiSummary }) })] }) }, document.id)); }) })] }), _jsx(Box, { sx: {
                                        flexGrow: 1,
                                        padding: '16px 20px',
                                        overflowY: 'auto',
                                        mt: 8.5
                                    }, children: messages === null || messages === void 0 ? void 0 : messages.map(function (chat, index) { return (_jsxs(Fragment, { children: [_jsx("div", { id: "user-message-".concat(index), children: _jsx(UserMessage, { question_type: chat.question_type, message: chat.question, time: new Date(chat.time).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: true
                                                    }) }) }), _jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', mb: 2, mt: 2, children: _jsx(Box, { children: _jsx(AiAuditMessage, { message: chat, onViewDocumentClose: handleViewDocumentClose, onViewDocumentOpen: function () { return handleViewDocumentOpen(chat); }, onUuidSelect: handleUuidSelection, onDocContentSelect: handleSourceSelection, onDocContentsSelect: handleContentSelection, onSourcesSelect: function () { return handleSourcesSelection(chat.message_id); }, isExpanded: isExpanded }) }) })] }, index)); }) })] }) }), isDocumentViewOpen &&
                        (!isXs && !isIpad ? (_jsx(Grid, { size: { xs: 12, sm: isExpanded ? 9 : 6 }, children: _jsx(Box, { bgcolor: '#F4F6F8', sx: { borderTopLeftRadius: 0 }, children: _jsx(FileViewerDialog, { open: isDocumentViewOpen, message_id: selectedMessageId, onClose: handleViewDocumentClose, OnTranslatedTextSelection: handleTranslatedTextSelection, isFetching: false, source: selectedSource, sources: selectedSources, sourceDocument: selectedDocument, doc_content: selectedDocContent, hash_id: selectedUuid, scroll_id: selectedScrollId, document_name: selectedDocumentName, isActualChat: false, toggleExpanded: toggleExpanded, isExpanded: isExpanded, setIsExpanded: setIsExpanded }) }) })) : (_jsx(Drawer, { anchor: isXs ? 'bottom' : 'right', open: isDocumentViewOpen, onClose: function () { return setDocumentViewOpen(false); }, sx: {
                                '& .MuiDrawer-paper': {
                                    height: '100%',
                                    width: isIpad ? '500px' : undefined,
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16,
                                    overflow: 'hidden'
                                }
                            }, children: _jsx(FileViewerDialog, { open: isDocumentViewOpen, message_id: selectedMessageId, onClose: handleViewDocumentClose, OnTranslatedTextSelection: handleTranslatedTextSelection, sources: selectedSources, isFetching: false, source: selectedSource, sourceDocument: selectedDocument, doc_content: selectedDocContent, hash_id: selectedUuid, scroll_id: selectedScrollId, document_name: selectedDocumentName, isActualChat: false, toggleExpanded: toggleExpanded, isExpanded: isExpanded, setIsExpanded: setIsExpanded }) })))] }), viewDocument.document && (_jsx(ViewDocument, { documentId: viewDocument.document.id, filePath: viewDocument.document.filePath, title: viewDocument.document.title, open: viewDocument.isOpen, onClose: function () { return setViewDocument({ isOpen: false }); } }))] }));
};
export default AuditFeedback;
